var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.accessKeys, function (item, idx) {
      return _c(
        "form-group",
        { key: idx, attrs: { label: item.displayName, name: item.name } },
        [
          item.type === "select"
            ? _c(
                "md-select",
                {
                  model: {
                    value: item.value,
                    callback: function ($$v) {
                      _vm.$set(item, "value", $$v)
                    },
                    expression: "item.value",
                  },
                },
                _vm._l(item.options, function (option, jdx) {
                  return _c(
                    "md-option",
                    { key: jdx, attrs: { value: option.value } },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(option.displayName) +
                          "\n            "
                      ),
                    ]
                  )
                }),
                1
              )
            : _c("md-input", {
                attrs: { type: item.type },
                model: {
                  value: item.value,
                  callback: function ($$v) {
                    _vm.$set(
                      item,
                      "value",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "item.value",
                },
              }),
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }